export default __webpack_public_path__ + "static/desktop_11-c70cb7ddbf15de1d5d5d1496865b2eca.webp";